import { Tooltip } from "@mui/material";
import { format, parse } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import { StatusConsultaPrevia } from "../../components/StatusConsultaPrevia/StatusConsultaPrevia";


const columnsConsultaPrevia = [
    { 
        field: 'Situacao',
        headerName: 'Situação',
        renderCell: (params) => (
            <StatusConsultaPrevia value={params.value} />
        )
    },
    { field: 'CodigoVisual', headerName: 'Código consulta', flex: 1, 
        renderCell: (params) => (
            <Tooltip title={ params.value } placement="bottom">
                <p>{ params.value }</p>
            </Tooltip>
        )
    },
    { field: 'Protocolo', headerName: 'Protocolo', flex: 1, 
        renderCell: (params) => (
            <Tooltip title={ params.value } placement="bottom">
                <p>{ params.value }</p>
            </Tooltip>
        )
    },
    { field: 'Nome', headerName: 'Nome', flex: 2, 
        renderCell: (params) => (
            <Tooltip title={ params.value } placement="bottom">
                <p>{ params.value }</p>
            </Tooltip>
        )
    },
    { field: 'Inscricao', headerName: 'Inscrição', flex: 1.5,
        renderCell: (params) => {
            if (!params.value) {
                return '';
            }

            if (params?.row?.TipoInscricao === 1) {
                return params.value.replace(/^([\d]{3})([\d]{3})([\d]{3})([\d]{2})$/, "$1.$2.$3-$4")
            } else {
                return params.value.replace(/([A-Za-z0-9]{2})([A-Za-z0-9]{3})([A-Za-z0-9]{3})([A-Za-z0-9]{4})([A-Za-z0-9]{2})/, '$1.$2.$3/$4-$5')
            }
        }
    },
    { field: 'TipoProjeto.Nome', headerName: 'Tipo do projeto', flex: 2, 
        renderCell: (params) => (
            <Tooltip title={ params.value } placement="bottom">
                 <p>{params.row.TipoProjeto.Nome}</p>
            </Tooltip>
        )
    },
    { field: 'RespTecnico.Nome', headerName: 'Responsável técnico', flex: 2,
        renderCell: (params) => (
            <Tooltip title={ params.value } placement="bottom">
                <p>{ params.row.RespTecnico.Nome }</p>
            </Tooltip>
        )
    },
    {  field: 'DataCadastro', headerName: 'Data de cadastro', flex: 0.8,
        renderCell: (params) => {
            let dataFormatada = parse(params?.row?.DataCadastro, 'dd/MM/yyyy HH:mm:ss', new Date());

            dataFormatada = format(dataFormatada, 'dd/MM/yyyy', {
                locale: ptBR
            });
            
            return dataFormatada;
        }
    }]

export { columnsConsultaPrevia };